import { useRef } from 'react';
import _ from 'lodash';

const useValue = value => {
  const ref = useRef(value);

  if (!_.isEqual(ref.current, value)) {
    ref.current = value;
  }

  return ref.current;
};

export default useValue;
